import React from 'react';
import {connect} from 'react-redux';
import PropTypes from "prop-types";

import {setDiscountSections} from "./discountsActions";
import {
  discountInterFace,
  discountSectionsInterface,
} from "./discountsInterface";
import {getUpdatedSections} from "./discountsFunctions";
import CheckBox from "../PageLayout/CheckBox";


const DiscountAllRoomsCheckbox = (props) => {

  const {discount, discountSection, discountSections, setDiscountSections, workSheetsCount} = props;

  if (workSheetsCount <= 1) {
    return null
  }

  let parsedOptions = typeof discount.wizardOptions === "string"
    ? JSON.parse(discount.wizardOptions)
    : {};

  const onChecked = () => {
    parsedOptions.forOneRoom = !parsedOptions.forOneRoom;
    let newSections = getUpdatedSections(discountSections,
      discountSection,
      discount,
      "wizardOptions",
      JSON.stringify(parsedOptions)
    )
    setDiscountSections(newSections);
  }

  return (
    <CheckBox checked={!parsedOptions.forOneRoom}
              onChecked={onChecked}
              text="All Rooms"/>
  )
}

DiscountAllRoomsCheckbox.propTypes = {
  discount: PropTypes.shape(discountInterFace),
  discountSection: PropTypes.shape(discountSectionsInterface),
}

const mapStateToProps = (store) => {
  const {workSheetsCount, discountSections} = store.discountsState;
  return {
    discountSections,
    workSheetsCount,
  };
};

const mapDispatchToProps = {
  setDiscountSections
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscountAllRoomsCheckbox);
